import PaddockAvatar from '@/components/ui/paddock-avatar/paddock-avatar';
import getCallMeBy from '@/components/user/get-call-me-by';
import type { User } from '@/models/types';
import { Circle } from 'lucide-react';

const ProfileCard = ({ user }: { user: User; isOnline?: boolean }) => {
  const { avatar, first_name, last_name, role } = user;

  return (
    <div className="flex flex-row gap-2 items-center">
      <div className="relative">
        <PaddockAvatar
          src={avatar}
          alt={`${first_name} ${last_name}`}
          fallback={`${first_name.charAt(0)} ${last_name.charAt(0)}`}
          className="size-6"
        />
        <div className="absolute bottom-0 -right-0.5 bg-white rounded-full size-2 flex">
          <Circle className="size-2 text-green-500 fill-green-500" />
        </div>
      </div>
      <div className="flex flex-col gap-0">
        <div className="text-xs  text-black text-nowrap">
          {getCallMeBy(user)}
        </div>
        <div className="text-xs  text-gray-500 text-nowrap">Online</div>
      </div>
      {role && (
        <div className="text-xs text-start  text-gray-500 text-nowrap bg-gray-100 px-1 h-full">
          {role.split('_').join(' ')}
        </div>
      )}
    </div>
  );
};

export default ProfileCard;
